import React from 'react';
import PropTypes from 'prop-types';
import cls from 'classnames/bind';

import OTTLogoWithText from '@ott/icon-ott-logo-with-text';
import Spreader from '@ott/spreader';

import s from './HeaderPartner.scss';

const cx = cls.bind(s);

class HeaderPartner extends React.PureComponent {
  static propTypes = {
    partner: PropTypes.object,
    className: PropTypes.string,
    project: PropTypes.string,
    headerAuthNode: PropTypes.element,
  };

  static defaultProps = {
    project: 'avia',
  };

  constructor(props, ctx) {
    super(props, ctx);
  }

  render() {
    const { project, className, partner, headerAuthNode, fixed, extraWide } = this.props;

    if (!partner) {
      return null;
    }

    return (
      <header
        className={cx('HeaderPartner', className, {
          'HeaderPartner--fixed': Boolean(fixed),
        })}
      >
        <Spreader theme={project} extraWide={extraWide} fixed={fixed}>
          <div className={cx('wrap')}>
            <OTTLogoWithText project={project} to="/" isInternal={false} className={cx('logo')} />
            <div className={cx('with')}>
              <div className={cx('sep')} />
              <a className={cx('link')} href={partner.link}>
                <img className={cx('partnerLogo')} src={partner.logo} />
              </a>
            </div>
            {headerAuthNode}
          </div>
        </Spreader>
      </header>
    );
  }
}

export default HeaderPartner;
